/**
 * House of Places — map search: one row per PLACE, not per poster.
 *
 * Typing "la jolla" used to list every matching poster on its own row
 * ("La Jolla", "La Jolla", "La Jolla San Diego", "La Jolla Shores",
 * "San Diego la Jolla"...). Now the posters Shopify's search finds are
 * grouped by the place in their title, so "la jolla" gives ONE row,
 * "La Jolla", and clicking it opens a results page with every poster whose
 * title names La Jolla (Shopify search: title:"la jolla").
 *
 * Grouping: from each title the place is taken from the word where the typed
 * text starts to the end of the place name, so "La Jolla Shores" and
 * "San Diego la Jolla" both give "La Jolla ...". Longer names join a shorter
 * one they start with ("La Jolla Shores" -> "La Jolla"). The detail after the
 * dash ("Windansea Beach – La Jolla") is used only when no place name matched.
 */
(function () {
  function norm(s) {
    return String(s || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parse(title) {
    var t = String(title || '');
    var place = t.split(/\s+Travel Poster/i)[0].trim();
    var rest = '';
    var m = t.match(/Travel Poster\s*[–—-]\s*(.+?)\s*Wall Art Print\s*$/i);
    if (m) rest = m[1].trim();
    return { place: place || t, detail: rest };
  }

  // From the word where q starts to the end of the text, or null.
  function span(text, q) {
    var n = norm(text);
    var i = n.indexOf(q);
    if (i === -1) return null;
    // Only a match at the start of a word: "sant" must not hit "Désanto".
    if (i > 0 && n.charAt(i - 1) !== ' ' && n.charAt(i - 1) !== '-') {
      i = n.indexOf(' ' + q);
      if (i === -1) return null;
      i += 1;
    }
    // Same length after norm for plain text; accented text falls back to
    // title case of the normalised words.
    var tidy = text.replace(/\s+/g, ' ').trim();
    var out = tidy.length === n.length ? tidy.slice(i) : n.slice(i).replace(/(^|[\s-])(\w)/g, function (m, a, c) {
      return a + c.toUpperCase();
    });
    return out.replace(/[,\s]+$/, '');
  }

  function groups(products, qRaw) {
    var q = norm(qRaw);
    var fromPlace = [];
    var fromDetail = [];
    products.forEach(function (p) {
      var info = parse(p.title);
      var a = span(info.place, q);
      if (a) fromPlace.push(a);
      else {
        var b = info.detail && span(info.detail, q);
        if (b) fromDetail.push(b);
      }
    });
    var names = fromPlace.length ? fromPlace.concat(fromDetail) : fromDetail;
    names.sort(function (x, y) {
      return norm(x).length - norm(y).length;
    });
    var list = [];
    names.forEach(function (name) {
      var n = norm(name);
      var g = null;
      for (var i = 0; i < list.length; i++) {
        if (n === list[i].key || n.indexOf(list[i].key + ' ') === 0) {
          g = list[i];
          break;
        }
      }
      if (!g) {
        g = { key: n, label: name, count: 0 };
        list.push(g);
      }
      g.count++;
      // Prefer a capitalised spelling: "La Jolla" over "la Jolla".
      if (n === g.key && /^[A-Z]/.test(name) && !/^[A-Z]/.test(g.label)) g.label = name;
    });
    list.sort(function (x, y) {
      var sx = x.key.indexOf(q) === 0 ? 0 : 1;
      var sy = y.key.indexOf(q) === 0 ? 0 : 1;
      return sx - sy || y.count - x.count || x.key.localeCompare(y.key);
    });
    return list.slice(0, 5);
  }

  function hedef(label) {
    var base = window.routes && window.routes.search_url ? window.routes.search_url : '/search';
    return (
      base +
      '?q=' +
      encodeURIComponent('title:"' + label + '"') +
      '&type=product&options%5Bprefix%5D=last'
    );
  }

  function kur(root) {
    var input = root.querySelector('[data-hop-map-search]');
    var box = root.querySelector('[data-hop-map-suggestions]');
    if (!input || !box || root.hopAramaKuruldu) return;
    root.hopAramaKuruldu = true;

    var timer = null;
    var seq = 0;

    function add(list) {
      Array.prototype.slice.call(box.querySelectorAll('[data-hop-poster-hit]')).forEach(function (n) {
        n.remove();
      });
      if (!list.length) return;
      var none = box.querySelector('.hop-map__sug--none');
      if (none) none.remove();
      // The map's own city rows for the same place would be a second row
      // saying the same thing; the place row replaces them.
      var keys = list.map(function (g) {
        return g.key;
      });
      Array.prototype.slice.call(box.querySelectorAll('.hop-map__sug')).forEach(function (row) {
        var first = row.firstChild;
        var name = first && first.nodeType === 3 ? first.nodeValue : '';
        if (keys.indexOf(norm(name)) !== -1) row.remove();
      });
      var first = box.firstChild;
      list.forEach(function (g) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-hop-poster-hit', '');
        b.className = 'hop-map__sug is-available';
        b.textContent = g.label;
        var kind = document.createElement('span');
        kind.className = 'hop-map__sug-type';
        kind.textContent = 'Posters';
        b.appendChild(kind);
        b.addEventListener('click', function () {
          box.hidden = true;
          window.location.href = hedef(g.label);
        });
        box.insertBefore(b, first);
      });
      box.hidden = false;
    }

    function ara() {
      var q = input.value.trim();
      if (q.length < 2) return;
      var mine = ++seq;
      var url =
        (window.routes && window.routes.predictive_search_url ? window.routes.predictive_search_url : '/search/suggest') +
        '.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,tag&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (j) {
          if (!j || mine !== seq || input.value.trim() !== q) return;
          var products = (j.resources && j.resources.results && j.resources.results.products) || [];
          add(groups(products, q));
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(ara, 180);
    });
  }

  // Exposed for a quick check from the console / tests.
  window.hopMapSearchGroups = groups;

  document.querySelectorAll('[data-hop-map]').forEach(kur);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hop-map]').forEach(kur);
  });
})();
